import CheckboxGroup from "@components/CheckboxGroup";
import Collapsible from "@components/Collapsible";
import type { Props } from "./types";

export default function CollapsibleCheckboxGroup({
	title,
	options,
	columns,
	open,
	onChange,
	orientation,
	value,
	onOpen,
	defaultOpen,
	multiple,
}: Props) {
	return (
		<Collapsible
			title={title}
			open={open}
			onOpen={onOpen}
			defaultOpen={defaultOpen}
		>
			<CheckboxGroup
				options={options}
				value={value}
				orientation={orientation}
				onChange={onChange}
				columns={columns}
				multiple={multiple}
			/>
		</Collapsible>
	);
}
